import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import basicsStyle from 'assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx';
import 'react-confirm-alert/src/react-confirm-alert.css';
import _ from 'lodash-es';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { frontEndTools } from './tools';
import { InputLabel, Box } from '@material-ui/core';

const FrontEndCard = React.forwardRef(
  (
    {
      handleChange,
      frontEndTool,
      frontEndMockRef,
      frontEndDesignMockRef,
      frontEndViewNameField,
      frontEndViewNavigationField,
      onFrontEndEditorDescStateChange,
      frontEndEditorDescState,
      frontEndEditorWorkFlowState,
      onFrontEndEditorWorkFlowStateChange,
      frontEndSwaggerField,
      handleKeyDown,
    },
    ref
  ) => {
    return (
      <Fragment>
        <Grid item sm={12} md={12} lg={6}>
          <TextField
            id='select-story-type'
            name='frontEndTool'
            label='Programming Tools'
            select
            fullWidth
            margin='dense'
            value={frontEndTool}
            onChange={handleChange}
          >
            {frontEndTools.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='frontEndMockRef'
            label='Mock Reference'
            fullWidth={true}
            margin='dense'
            value={frontEndMockRef}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='frontEndDesignMockRef'
            label='Design Mock Reference'
            fullWidth={true}
            margin='dense'
            value={frontEndDesignMockRef}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='frontEndViewNameField'
            label='View name'
            fullWidth={true}
            margin='dense'
            value={frontEndViewNameField}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='frontEndViewNavigationField'
            label='View navigation'
            fullWidth={true}
            margin='dense'
            value={frontEndViewNavigationField}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>Description</InputLabel>
          <Box borderBottom={1}>
            <Editor
              editorState={frontEndEditorDescState}
              toolbarClassName='toolbarClassName'
              editorClassName='editorClassName'
              onEditorStateChange={onFrontEndEditorDescStateChange}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <InputLabel>Workflow</InputLabel>
          <Box borderBottom={1}>
            <Editor
              editorState={frontEndEditorWorkFlowState}
              toolbarClassName='toolbarClassName'
              editorClassName='editorClassName'
              onEditorStateChange={onFrontEndEditorWorkFlowStateChange}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='frontEndSwaggerField'
            label='Swagger Reference'
            fullWidth={true}
            margin='dense'
            value={frontEndSwaggerField}
            onChange={handleChange}
            inputRef={ref.backEndViewNavigationRef}
            onKeyDown={handleKeyDown}
          />
        </Grid>
      </Fragment>
    );
  }
);

export default FrontEndCard;
